import { axiosMicroservice } from 'src/api/axios';
import type { TpStripeCreateInvoice } from 'src/features/Stripe/types';

const upsellUrlMap = {
  braintree: 'braintree_upsell',
  stripe: 'stripe/create_invoice',
};

export const createInvoice = async ({
  customerId,
  amount,
  paymentSystem,
  currency,
  app = 'FaceYoga',
}: TpStripeCreateInvoice): Promise<{ message: string }> => {
  const { data } = await axiosMicroservice.post(
    `${upsellUrlMap[paymentSystem]}`,
    {
      app,
      amount: amount,
      currency: currency,
      customer_id: paymentSystem === 'stripe' ? customerId : undefined,
      user_id: paymentSystem === 'braintree' ? customerId : undefined,
    },
  );
  return data;
};
